import React, { useState, useEffect } from 'react';
import Modal from '../../../common/components/Modal/modal';
import KYCImage from '../../../images/icons/KYCComplete.svg';
import { getCustomerDetails } from '../../../common/constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { navigate } from 'gatsby';
import { staticData } from 'gatsby-env-variables';
const IncomeSuccessPopUp = () => {
  const [show, setShow] = useState('');
  const [popUpShow, setPopUpShow] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('');
  const [isAllowdToNext, setIsAloowed] = useState(
    staticData?.isLems ? false : true
  );
  const [isLAP, setIsLAP] = useState(false);
  useEffect(() => {
    let applicant = getApplicantionInfo();
    if (staticData?.isLems) {
      applicant.mainApplicant && setIsAloowed(true);
    }
    setPopUpShow(true);
    setPopUpType('loading');
    setPopUpText('Fetching the Loan Details ...');
    getCustomerDetails(applicant.leadId)
      .then(res => {
        if (
          res?.productId == 12 ||
          res?.productId == 13 ||
          res?.productId == 14
        ) {
          setDashboardBtn(true);
        }
        if (res?.productId == 2) setIsLAP(true);
        setPopUpShow(false);
      })
      .catch(err => {
        if (err?.response?.data?.status == 400) {
          setPopUpShow(false);
        } else {
          setPopUpType('fail');
          setPopUpText(
            err?.response?.data?.message ||
              'something gone wrong!please try again..'
          );
        }
      });
  }, []);
  return (
    <React.Fragment>
      <Modal show={true} noCloseBtn={false} setShow={setShow}>
        <div className="w-full  px-4">
          <div className="w-full py-10">
            <p className="font-roboto font-medium mr-auto text text-green-600 text-xl"></p>
          </div>

          <div className="w-full">
            <p className="text-orange-600 font-roboto font-bold py-2">
              Congratulations!
            </p>
            <p className="text-black-400 font-roboto font-normal py-2">
              Your Income Details has been added successfully
            </p>
            <p className="text-black-0 font-roboto font-normal my-4 text-sm">
              You are now only 1 step away from your Provisional Sanction Letter
            </p>
            <div className="">
              <img className="mx-auto" src={KYCImage} />
            </div>
            <div className="">
              <button
                className="submitButton"
                onClick={() => {
                  isAllowdToNext
                    ? isLAP
                      ? navigate(
                          staticData?.lapPropertyUrl || '/user/LAP/property'
                        )
                      : navigate(
                          staticData?.propertyDetailsURl ||
                            '/user/propertyDetails'
                        )
                    : navigate(staticData?.dashboardURl || '/user/dashboard');
                }}
              >
                {isAllowdToNext ? 'Add Property Details' : 'Goto DashBoard'}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <PopUp
        type={popUpType}
        text={popUpText}
        setShow={setPopUpShow}
        show={popUpShow}
      />
    </React.Fragment>
  );
};

export default IncomeSuccessPopUp;
